export { ExtensionPoints, default } from './languages.js';
